import TaskStatus from '@/enums/TaskStatus';
import ITaskItem from '@/interfaces/ITaskItem';

export default function createTask(): ITaskItem {
  return {
    id: 0,
    title: '',
    description: '',
    status: TaskStatus.WAITING,
    createdAt: new Date(),
    startedAt: undefined,
    finishedAt: undefined,
    response: undefined,
  };
}
